import axios from 'axios';

import routes from 'app/routes';

export default function getPaymentMethodLink({ paymentInformationId }) {
  return axios
    .post(routes.api.managers.payment_methods.link, {
      payment_information_id: paymentInformationId,
    })
    .then((response) => response.data);
}
